fragment DocumentTagger on Document {
  id
  tagger
}
